<template>
  <section class="hero is-fullheight">
    <div class="hero-body">
      <div class="container">
        <b-loading
          :is-full-page="true"
          :active="isLoading"
          :can-cancel="false"
        ></b-loading>

        <div class="columns">
          <div class="column"></div>
          <div class="column is-half has-text-centered">
            <h1 class="title is-spaced">
              {{ $t("forgotPassword.title") }}
            </h1>
            <h2 class="subtitle">
              {{ $t("forgotPassword.subtitle1") }}
              <br />
              {{ $t("forgotPassword.subtitle2") }}
            </h2>

            <form @submit.prevent="forgotPassword" class="has-text-centered">
              <b-field>
                <b-input
                  size="is-medium"
                  v-model="email"
                  class="is-expanded"
                  type="email"
                  :placeholder="$t('common.email')"
                ></b-input>
              </b-field>

              <button
                class="button is-medium is-fullwidth has-text-weight-bold"
                :style="{
                  backgroundColor: $primaryColor,
                  color: $primaryColorContrast
                }"
              >
                {{ $t("forgotPassword.sendLink") }}
              </button>

              <br />
              <div class="has-text-left">
                <router-link to="/" tag="button" class="button">
                  <b-icon icon="arrow-alt-circle-left"></b-icon>
                  &nbsp;&nbsp; {{ $t("common.back") }}
                </router-link>
              </div>
            </form>
          </div>
          <div class="column"></div>
        </div>
      </div>
    </div>

    <div class="hero-footer">
      <flag-icons />
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common.js";
import flagIcons from "./common/FlagIcons";

export default {
  mixins: [common],

  components: {
    flagIcons
  },

  data() {
    return {
      email: "",
      isLoading: false
    };
  },

  methods: {
    forgotPassword() {
      this.isLoading = true;
      this.$store
        .dispatch("forgotPassword", {
          email: this.email
        })
        .then(res => {
          if (res.data.result === "ok") {
            this.$buefy.dialog.alert({
              title: this.$t("forgotPassword.linkSent"),
              message: this.$t("forgotPassword.linkSentMessage"),
              type: "is-success",
              hasIcon: true,
              icon: "check",
              iconPack: "fa",
              onConfirm: () => this.$router.push("/"),
              onCancel: () => this.$router.push("/")
            });
          } else {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },

  computed: {
    ...mapGetters(["locale"])
  },

  mounted() {
    this.$store.dispatch("setLocale", this.locale);
  }
};
</script>

<style>
form {
  width: 80%;
  margin: auto;
}
</style>
